export enum WSMsgType {
  Comments = "comments",
  DataDetails = "dataDetails",
}
